<template>
  <div class="department">
    <headerBar></headerBar>
    <banner></banner>
    <div>
       <div style="text-align:center;margin:20px 0 10px;">
            <img src="@/assets/ksjs1.png" alt="">
       </div>
       <div class="flex-center" style="justify-content: center;font-size:26px;margin:40px 0 50px;">
           <div style="margin-right:20px;">一切以治愈为目的</div>
           <div>一切为了人类健康</div>
       </div>
       <div style="text-align:center;margin:20px 0;">
           <img src="@/assets/ksjs.png" alt="" style="width:50%;">
       </div>
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import banner from "@/components/banner";
import headerBar from "@/components/header";
import footerBar from "@/components/footer";
export default {
  name: "department",
  components: { banner, footerBar, headerBar },
  data() {
    return {
      activeIndex: "",
    };
  },
  methods: {
    handleSelect() {
      console.log(this.activeIndex);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/views/department.vue